// Starting an OAuth connection (2026-10-12). Every Connect button sent the browser to
// /api/auth/<provider>, which answers a navigation 401 since C1 (a navigation carries no token), so
// no new connection could be made after 2026-09-10. The app now asks the start route WITH its token
// (Aidey Backend/lib/oauthStart.js) and follows only an https link it gets back. A refusal is thrown
// (api() throws ApiError with the server's message) for the caller to show at its own control.
import { api } from '../api/client';

// { reconnect: true } (2026-10-21): the server opens the provider's sign-in on the mailbox already
// stored for this provider (a login hint read from the stored row, never from the URL).
export async function startOAuth(provider, { reconnect = false } = {}) {
  const res = await api(`/api/auth/${provider}/start${reconnect ? '?reconnect=1' : ''}`);
  const data = await res.json();
  const url = data && typeof data.url === 'string' ? data.url : '';
  if (!/^https:\/\//.test(url)) throw new Error('The connection could not be started. Please try again.');
  window.location.assign(url);
}
